import { useEffect } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import TrustBar from "@/components/landing/TrustBar";
import Features from "@/components/landing/Features";
import KeyFigures from "@/components/landing/KeyFigures";
import HowItWorks from "@/components/landing/HowItWorks";
import VideoShowcase from "@/components/landing/VideoShowcase";
import UseCases from "@/components/landing/UseCases";
import Specs from "@/components/landing/Specs";
import Comparison from "@/components/landing/Comparison";
import Offres from "@/components/landing/Offres";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import ContactForm from "@/components/landing/ContactForm";
import Footer from "@/components/landing/Footer";
import FloatingCTA from "@/components/landing/FloatingCTA";
import EditorialMarquee from "@/components/landing/EditorialMarquee";
import { HOME_FAQ } from "@/data/homeFaq";

export default function LandingPage() {
  // FAQPage structured data for the home page (rich results)
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-faq-home", "1");
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: HOME_FAQ.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => { script.remove(); };
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#FAFAFA] text-[#0A0A0A] antialiased">
      <div data-testid="grain-overlay" aria-hidden="true" className="grain-overlay pointer-events-none fixed inset-0 z-[100] opacity-[0.05]" />
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <Features />
        <KeyFigures />
        <HowItWorks />
        <EditorialMarquee />
        <VideoShowcase />
        <UseCases />
        <Specs />
        <Comparison />
        <Offres />
        <Testimonials />
        <FAQ items={HOME_FAQ} />
        <ContactForm />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
